<template>
    <svg width="6" height="8" viewBox="0 0 6 8" fill="none" xmlns="http://www.w3.org/2000/svg" :class="className">
        <g clip-path="url(#clip0_1_3)">
            <path d="M1.77408 2.21286C1.77408 1.70416 2.25848 1.18106 3.00056 1.18106C3.74263 1.18106 4.22704 1.70416 4.22704 2.21286C4.22704 2.56607 4.00759 2.91132 3.61702 3.10411C3.11649 3.35117 2.41003 3.8876 2.41003 4.7437V4.95754C2.41003 5.28368 2.67442 5.54807 3.00056 5.54807C3.3267 5.54807 3.59109 5.28368 3.59109 4.95754V4.7437C3.59109 4.59629 3.74046 4.36028 4.13978 4.16317C4.86916 3.80315 5.4081 3.0831 5.4081 2.21286C5.4081 0.929583 4.2655 0 3.00056 0C1.73562 0 0.593018 0.929583 0.593018 2.21286C0.593018 2.539 0.857406 2.80339 1.18355 2.80339C1.50969 2.80339 1.77408 2.539 1.77408 2.21286Z" fill="white"/>
            <path d="M3.00047 8C3.41574 8 3.75238 7.66336 3.75238 7.24809C3.75238 6.83282 3.41574 6.49617 3.00047 6.49617C2.5852 6.49617 2.24856 6.83282 2.24856 7.24809C2.24856 7.66336 2.5852 8 3.00047 8Z" fill="white"/>
        </g>
        <defs>
            <clipPath id="clip0_1_3">
                <rect width="6" height="8" fill="white"/>
            </clipPath>
        </defs>
    </svg>
</template>

<script>
export default {
    name: 'IconQuestion',

    props: ['className']
};
</script>

<style lang="scss">
@import "Icons";
</style>
